import React, { Fragment, useMemo } from "react";
import { message, Modal } from "antd";
import "./dept-add-user-modal.less";
import { lib } from "../../index";

export default function DeptUserCancelPermissionModal({ departmentId, deptName, cancelRow = [], onClose, visible }) {
    function okHandle() {
        const userIds = cancelRow.reduce((pre, cur) => [...pre, cur.id || cur.userId], []);
        lib.request({
            url: "/ucenter-admin/dept/user/batch/unbind",
            data: {
                departmentId,
                userIds,
                systemCode: lib.config.systemCode,
            },
            needMask: true,
            success: res => {
                onClose(true);
                message.success("移除成功！");
            },
        });
    }

    function onCancelHandle() {
        onClose(false);
    }

    const displayNameArr = useMemo(
        () =>
            cancelRow.map((item, index) => {
                return (
                    <span key={index}>
                        <span className={"link cursor-auto"}>{item.userName}</span>
                        {index < cancelRow.length - 1 ? "、" : ""}
                    </span>
                );
            }),
        [cancelRow],
    );

    return (
        <Modal
            title={"移除人员"}
            open={visible}
            maskClosable={false}
            destroyOnClose={true}
            onOk={() => okHandle()}
            onCancel={() => onCancelHandle()}>
            <div>
                是否确认将人员{displayNameArr}从部门<span className={"link cursor-auto"}>{deptName}</span>中移除？
            </div>
        </Modal>
    );
}
